export const popups = [
    {
        id: 'it',
        title: 'Те, кто создают цифровое будущее',
        jobs: [
            'Программирование',
            'Веб-разработка',
            'IT-поддержка',
            'Сетевое администрирование',
        ],
        metrika: 'speciality6'
    },
        {
            //Информационная безопасность
            id: 'infosec',
            title: 'Те, кто защищают цифровой мир',
            jobs: ['Кибербезопасность', 'Защита компьютерных сетей', 'Тестирование на проникновение', 'Аудит безопасности'],
            metrika: 'speciality7'
        },
        {
            //Электро- и теплоэнергетика
            id: 'energetics',
            title: 'Те, кто дают свет и тепло городам',
            jobs: ['Эксплуатация электростанций', 'Обслуживание электросетей', 'Теплотехника', 'Монтаж ЛЭП'],
            metrika: 'speciality8',
        },
        {
            //Машиностроение
            id: 'machine',
            title: 'Те, кто конструируют и создают механизмы',
            jobs: ['Оператор станков с ЧПУ', 'Слесарь-сборщик', 'Технолог', 'Инженер-конструктор', 'Сварщик'],
            metrika: 'speciality9',
        },
        {
            //Химические технологии
            id: 'himtech',
            title: 'Те, кто создают новые материалы и вещества',
            jobs: ['Лаборант-химик', 'Аппаратчик', 'Нефтепереработка', 'Производство лекарств', 'Контроль качества'],
            metrika: 'speciality10',
        },
        {
            //Промышленная экология и биотехнологии
            id: 'biotech',
            title: 'Те, кто создают безопасные производства и продукты будущего',
            jobs: ['Экологический контроль', 'Биотехнология', 'Микробиология', 'Контроль выбросов', 'Очистка сточных вод'],
            metrika: 'speciality11',
        },
        {
            //Техносферная безопасность и природообустройство
            id: 'safetech',
            title: 'Те, кто защищают людей, технику и природу',
            jobs: ['Инспектор по охране труда', 'Пожарный', 'Спасатель МЧС', 'Инженер-эколог', 'Рекультивация земель'],
            metrika: 'speciality12',
        },
        {
            //Прикладная геология, горное дело, нефтегазовое дело и геодезия
            id: 'geology',
            title: 'Те, кто исследуют недра и находят полезные ископаемые',
            jobs: ['Геолог', 'Бурильщик', 'Маркшейдер', 'Геодезист', 'Оператор нефтегазовых установок'],
            metrika: 'speciality13',
        },
        {
            //Технологии материалов
            id: 'materials',
            title: 'Те, кто знают о металлах и сплавах всё',
            jobs: ['Металлург', 'Литейщик', 'Специалист по композитным материалам', 'Технолог резиновых изделий'],
            metrika: 'speciality14',
        },
        {
            //Техника и технологии наземного транспорта
            id: 'transport',
            title:' Те, кто поддерживают движение всего, что ездит по дорогам',
            jobs: ['Автомеханик', 'Автослесарь', 'Машинист локомотива', 'Специалист по автосервису'],
            metrika: 'speciality15',
        },
        {
            //Управление в технических системах
            id: 'techcontrol',
            title: 'Те, кто настраивают и управляют автоматикой и роботами',
            jobs: ['Наладчик КИПиА', 'Мехатроник', 'Специалист по автоматизации', 'Оператор автоматических линий'],
            metrika: 'speciality16',
        },
        {
            //Технологии легкой промышленности
            id: 'techprom',
            title: 'Те, кто создают вещи, которые нас окружают',
            jobs: ['Швея', 'Закройщик', 'Дизайнер одежды', 'Обувщик', 'Полиграфист'],
            metrika: 'speciality17',
        },
        {
            //Сельское, лесное и рыбное хозяйство
            id: 'agro',
            title: 'Те, кто работают с живыми природными ресурсами',
            jobs: ['Агроном', 'Тракторист-машинист', 'Животновод', 'Лесник', 'Рыбовод'],
            metrika: 'speciality18',
        },
        {
            //Сервис и туризм
            id: 'service',
            title: 'Те, кто создают комфорт, уют и яркие впечатления',
            jobs: ['Администратор гостиницы', 'Повар', 'Кондитер', 'Официант', 'Парикмахер', 'Турагент', 'Экскурсовод'],
            metrika: 'speciality19',
        },
        {
            //Образование и педагогические науки
            id: 'education',
            title: 'Те, кто учат и вдохновляют новое поколение',
            jobs: ['Воспитатель детского сада', 'Учитель начальных классов', 'Педагог доп. образования', 'Социальный педагог'],
            metrika: 'speciality20',
        },
        {
            // втб юрист
            id: 'pravo',
            title: 'Те, кто идеально разбирается в законах',
            jobs: ['Организация социального обеспечения', 'Правоохранительная деятельность', 'Судебное администрирование'],
            metrika: 'speciality4',
        },
        {
            // Торговое дело и логистика – Лемана ПРО
            id: 'trade',
            title: 'Те, кто организуют движение товаров',
            jobs: ['Товароведение', 'Коммерция', 'Логистика', 'Складское дело', 'Оптовая торговля'],
            metrika: 'speciality5',
        },
        {
            //Экономика и финанс втб
            id: 'economy',
            title:'Те, кто управляют финансами',
            jobs: ['Банковское дело', 'Финансы', 'Бухгалтерия', 'Менеджмент'],
            metrika: 'speciality3',
        },
        {
            //Электроника, радиотехника и системы связи – Билайн
            id: 'radioelectronic',
            title: 'Те, кто обеспечивают связь по всей стране',
            jobs: ['Техническое обслуживание сетей', 'Монтаж электронных приборов', 'Радиоаппаратостроение'],
            metrika: 'speciality2',
        },
        {
            //Техника и технологии строительства – Алабуга
            id: 'stroy',
            title: 'Те, кто возводит города и инфраструктуру',
            jobs: ['Строительство зданий', 'Эксплуатация инженерных систем', 'Дорожное строительство', 'Монтаж сантехники', 'Электромонтаж'],
            metrika: 'speciality1',
        },
]